var exports = {
  "P": "x1cb7f6e3--5f7cce--label",
};

module.exports = exports;
